import styled from 'styled-components/macro';

export const FlexContainer = styled.div`
  display: flex;
  padding-bottom: 15px;
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
`;

export const VerticalCenterContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: 15px;
`;

export const TableContainerOne = styled.div`
  padding-right: 15px;
`;
export const TableContainerTwo = styled.div`
  padding-left: 15px;
`;
